// K85StatBoard.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import K85Board from './K85Board';
import { getServerTime } from './actions';

import './k85board.css';

const distr = {
    'голо': "Голосіївський", 
    'дарн': "Дарницький", 
    'десн': "Деснянський", 
    'дніп': "Дніпровський", 
    'обол': "Оболонський", 
    'пече': "Печерський", 
    'под': "Подільський", 
    'свят': "Святошинський", 
    'солом': "Солом'янський", 
    'шевчен': "Шевченківський",
    'all': "Місто"
};

const parts = [
    "Розділ I",
    "Розділ II",
    "Розділ III",
    "Розділ IV",
    "Розділ V",
    "Розділ VI",
    "Розділ VII"
];

const typestat = [
    { title: "Відредагована інформація", value: "changed" }, 
    { title: "Первинна інформація", value: "original" }
];

const getArrPeriods = (curDate) => {
    const startPeriod = new Date('2021-12-01');
    
    const [curY, curM] = [curDate.getFullYear(), curDate.getMonth()];

    const periods = [
        `${curM+1}.${curY}`
    ];

    for(;;) {
        const [cM, cY] = periods[periods.length - 1].split('.');
        
        const newM = (+cM-1) > 0 ? (+cM - 1) : 12;
        const newY = (+cM-1) > 0 ? (+cY) : (+cY - 1);

        if(new Date(newY, newM-1, 2) < startPeriod) break;
        
        periods.push(`${newM}.${newY}`);
    }

    return periods;
};

const K85StatBoard = () => {
    const [part, setPart] = useState(0);
    const [period, setPeriod] = useState(null);
    const [district, setDistrict] = useState('голо');
    const [type, setType] = useState(typestat[0].value);
    const [periods, setPeriods] = useState([]);

    useEffect(() => {
        setCurDate();
    }, []);

    const setCurDate = useCallback(() => {
        getServerTime(
            (date) => setPeriods(getArrPeriods(new Date(date['timestamp']))),
            (err) => console.log(`error get serverTime ${JSON.stringify(err)}`)
        );
    }, []);

    const handleDistrictChange = useCallback((e) => setDistrict(e.target.value), []);
    const handlePeriodChange = useCallback((e) => setPeriod(e.target.value), []);
    const handlePartChange = useCallback((e) => setPart(parseInt(e.target.value)), []);
    const handleTypeChange = useCallback((e) => setType(e.target.value), []);

    const currentPeriod = period || (periods.length > 0 ? periods[0] : '');

    return (
        <Container fluid className="bg-light py-4">
            <Row className="mb-4">
                <Col>
                    <div className="card k85-filters-card">
                        <div className="card-body">
                            <Row className="g-3 align-items-center">
                                <Col md={2}>
                                    <h5 className="card-title mb-0">Форма 85К</h5>
                                </Col>
                                <Col md={2}>
                                    <Form.Select value={district} onChange={handleDistrictChange}>
                                        {Object.keys(distr).map(d => 
                                            <option key={d} value={d}>{distr[d]}</option>
                                        )}
                                    </Form.Select>
                                </Col>
                                <Col md={2}>
                                    <Form.Select value={currentPeriod} onChange={handlePeriodChange}>
                                        {periods.map(p => 
                                            <option key={p} value={p}>{p}</option>
                                        )}
                                    </Form.Select>
                                </Col>
                                <Col md={2}>
                                    <Form.Select value={part} onChange={handlePartChange}>
                                        {parts.map((p, i) => 
                                            <option key={i} value={i}>{p}</option>
                                        )}
                                    </Form.Select>
                                </Col>
                                <Col md={4}>
                                    <Form.Select value={type} onChange={handleTypeChange}>
                                        {typestat.map(p => 
                                            <option key={p.value} value={p.value}>{p.title}</option>
                                        )}
                                    </Form.Select>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>
            <K85Board 
                period={currentPeriod} 
                district={district} 
                part={part} 
                type={type} 
                setCurDate={setCurDate}
            />
        </Container>
    );
};

export default K85StatBoard;